// A Company Profile's operating status, as main's `deriveCompanyBusinessStatus`
// derived it: out of business only when every known location is permanently
// closed, otherwise active.
export enum CompanyBusinessStatus {
  ACTIVE = "active",
  OUT_OF_BUSINESS = "out_of_business",
}

export const dataByCompanyBusinessStatus: Record<
  CompanyBusinessStatus,
  { label: string }
> = {
  [CompanyBusinessStatus.ACTIVE]: { label: "Active" },
  [CompanyBusinessStatus.OUT_OF_BUSINESS]: { label: "Out of business" },
}
